




















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import phoneCountryCodes from '../../configs/phoneCountryCodes';

@Component
export default class PhonePrefix extends Vue {
  @Prop({ default: '+48' }) public codeValue!: string;

  public phoneCode: string = '';
  public phoneCodes: any[] = [];
  public allPhoneCodes: any[] = [];

  public created() {
    for (const countryData of phoneCountryCodes) {
        this.phoneCodes.push({
            label: this.$t(`forms.options.langs.${countryData.code}`),
            value: countryData.dial_code,
        });
    }

    this.allPhoneCodes = [...this.phoneCodes];
  }

  public onCodeValueChange(val: string) {
    this.$emit('change', val);
  }

  public filterElems(query: string) {
    if (query) {
      const lowerQuery = query.toLowerCase();
      this.phoneCodes = this.allPhoneCodes.filter((item: any) => {
        return (
          item.label.toLowerCase().includes(lowerQuery) ||
          item.value.includes(lowerQuery)
        );
      });
    } else {
      this.phoneCodes = [...this.allPhoneCodes];
    }
  }

  public resetOptions() {
    this.phoneCodes = [...this.allPhoneCodes];
  }
}
